import { render, staticRenderFns } from "./IdiResearchProfessor.html?vue&type=template&id=6af31944&scoped=true&external"
import script from "./IdiResearchProfessor.vue?vue&type=script&lang=js"
export * from "./IdiResearchProfessor.vue?vue&type=script&lang=js"
import style0 from "./IdiResearchProfessor.scss?vue&type=style&index=0&id=6af31944&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af31944",
  null
  
)

export default component.exports